import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@elka/theme';
import { ErrorBoundary } from '@elka/layout';
import App from './App';
import './index.css';
// Ensure Firestore/auth are initialized before the router mounts (same pattern as CRM)
import './lib/firebase/config';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider storageKey="quotes-theme" defaultTheme="elkaBlue">
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>
);
